import { PRODUCT_TYPES } from "../constants";
import { S3URL } from "./conf";

export const mergeClass = (...classes: Array<string | undefined>) =>
  classes.filter(Boolean).join(" ");
export const attachNumPrefix = (
  num?: number,
  suffix?: string,
  suffix2?: string,
) =>
  num && num > 0
    ? num > 1
      ? num + " " + (suffix2 ?? suffix)
      : num + " " + suffix
    : "";

export const toNumberString = (str?: string): string =>
  (str ?? "").replace(/[^0-9]/g, "");

export const toAgeString = (str?: string): string => {
  const x = (str ?? "").replace(/[^0-9]/g, "");
  if (x === "0") {
    return "<1";
  }
  return x;
};
export const toAlphabetString = (str?: string): string =>
  (str || "").replace(/[^a-zA-Z]/g, "");

export const getProductTypeLabel = (type: string) => {
  const labels: Record<string, string> = {
    [PRODUCT_TYPES.PASS]: "Big Pass",
    [PRODUCT_TYPES.TICKET]: "Ticket",
    [PRODUCT_TYPES.TOUR]: "Tour",
    [PRODUCT_TYPES.MUSICAL]: "Musical",
    [PRODUCT_TYPES.SIM]: "Sim",
    [PRODUCT_TYPES.INACTIVE]: "Inactive List",
  };
  return labels[type] || "Other Products";
};

export const deepCopy = <T>(obj: T): T => {
  try {
    return JSON.parse(JSON.stringify(obj));
  } catch (e) {
    console.error("Error in deepCopy", e);
    return obj;
  }
};

export const isVideo = (filename: string) => {
  const extension = filename.split(".").pop() ?? "";
  return [
    "mp4",
    "webm",
    "ogg",
    "ogv",
    "mov",
    "wmv",
    "mpg",
    "flv",
    "mkv",
    "avi",
    "m4v",
    "3gp",
    "3g2",
  ].includes(extension);
};

export function replaceUrlCdn(input?: string): string {
  if (!input) return "";
  // if (input.endsWith(".svg")) return input;
  const target = S3URL;
  const replacement = process.env.REACT_APP_CDN_IMAGE;

  if (!target) return input;

  const escapedTarget = target.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  const regex = new RegExp(escapedTarget, "g");
  return input.replace(regex, replacement ?? "");
}

export const CDN_IMG = process.env.REACT_APP_CDN_IMAGE;
export const CDN_ASSET = process.env.REACT_APP_CDN_ASSET;
export const CDN_ASSET_ROOT = process.env.REACT_APP_CDN_ASSET_ROOT;
